export default "__VITE_ASSET__DzG5xlLA__"